/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useMemo, useState } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DefectTableColumns } from '../utils/helper';
import DataTable from '../../../Common/DataTable';
import StartTimeComponent from '../commonModal/StartTimeComponent';
import AddDefectComponent from '../commonModal/AddDefectComponent';
import ComponentDeleteModal from '../../../Common/DeleteModal/ComponentDeleteModal';
import InsertTimeComponent from '../commonModal/InsertTimeComponent';
import ReplaceComponent from '../commonModal/ReplaceComponent';
import { deleteVesselDefectStart, getVesselDefectStart, setCheckedData } from '../redux/DefectRedux/sliceVesselDefect';
import FinishTimeComponent from '../commonModal/FinishTimeComponent';
import { RootState } from '../../../redux/rootState';
import { DeleteDefectPayload, TypeDefectList } from '../utils/defectType';
import { setLoader } from '../../../redux/loaderSlice';
import localStorageConstants from '../../../utils/LocalStorageConstants';
import { ANALYST_ROLE_ID } from '../../../Routes/constant';
import { convertDateFormat } from '../../../utils/CommonFunctions';
import { showErrorToaster } from '../../../Common/ComponentToast/ComponentSuccessToasts';

function DefectComponent() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [showStartTimeModal, setShowStartTimeModal] = useState(false);
  const [showFinishTimeModal, setShowFinishTimeModal] = useState(false);
  const [showDefectModal, setShowDefectModal] = useState(false);
  // const [selectedId, setSelectedId] = useState('');
  const [selectedRowId, setSelectedRowId] = useState('');
  const [multiDelete, setMultiDelete] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [showInsertTimeModal, setShowInsertTimeModal] = useState(false);
  const [showReplaceModal, setShowReplaceModal] = useState(false);

  const { jobOrderId, vesselId } = useParams();

  const {
    vesselDefectList, isLoading, totalVesselDefect, startTime, endTime, checkedData,
  } = useSelector((state: RootState) => state.VesselDefectReducer);
  const roleId = localStorage.getItem(localStorageConstants.ROLE_ID);
  const [data, setData] = useState<TypeDefectList[]>([]);

  const handleDelete = (id: string) => {
    setDeleteModal(true);
    setSelectedRowId(id);
  };
  const handleMultiDelete = () => {
    if (checkedData?.every((item) => item?.defect === 'Calibration Time')) {
      setMultiDelete(true);
      setDeleteModal(true);
    } else if (checkedData?.every((item) => item?.action === 'edit&delete')) {
      setMultiDelete(true);
      setDeleteModal(true);
    } else {
      showErrorToaster('You can delete either multiple defects or multiple calibration time entries at a time. However, both types cannot be deleted simultaneously.');
    }
  };

  useEffect(() => () => {
    dispatch(setCheckedData([]));
  }, []);

  const handleDeleteModal = () => {
    const payload: DeleteDefectPayload = {
      id: selectedRowId,
      jobOrder: jobOrderId || '',
      vesselId: vesselId || '',
      page,
      rowsPerPage,
      searchQuery,
      vesselDefectData: vesselDefectList,
    };
    dispatch(deleteVesselDefectStart(payload));
    setDeleteModal(false);
    setSelectedRowId('');
  };
  const handleMultiDeleteConfirm = () => {
    const payload: DeleteDefectPayload = {
      id: checkedData,
      jobOrder: jobOrderId || '',
      vesselId: vesselId || '',
      page,
      rowsPerPage,
      searchQuery,
      vesselDefectData: vesselDefectList,
    };
    dispatch(deleteVesselDefectStart(payload));
    setDeleteModal(false);
    setSelectedRowId('');
    setMultiDelete(false);
    dispatch(setCheckedData([]));
  };

  const handleEdit = (id: string) => {
    const disableInsert = vesselDefectList.filter((item) => String(item.Id) === id);
    if (disableInsert[0].List === 'Start') {
      setSelectedRowId(id);
      setShowStartTimeModal(true);
    } else if (disableInsert[0].List === 'Finish') {
      setSelectedRowId(id);
      setShowFinishTimeModal(true);
    } else {
      setSelectedRowId(id);
      setShowDefectModal(true);
    }
  };

  const handleButtonClick = () => {
    setSelectedRowId('');
    setShowDefectModal(true);
  };

  const tableData: TypeDefectList[] = useMemo(() => {
    if (vesselDefectList?.length > 0) {
      const transformedData = vesselDefectList?.map((ele, index) => ({
        sn: index,
        action: `${ele.DefectType === 'Calibration Time' || ele.DefectType === 'Time Entry' || ele.DefectType === 'Time'
          ? ((roleId === ANALYST_ROLE_ID) ? '' : 'delete')
          : ele.DefectType === 'NMD' ? '' : ((roleId === ANALYST_ROLE_ID) ? 'eye' : 'edit&delete')}`,
        row: ele?.Row,
        tube: ele?.Tube,
        code: ele?.Code,
        location: ele?.Location,
        date: convertDateFormat(ele?.Date),
        time: ele?.Time,
        defect: ele?.Description,
        section: ele?.Section,
        status: ele?.Status,
        id: String(ele?.Id),
        isChecked: checkedData?.some((item) => item?.id === String(ele?.Id)),
      }));
      return transformedData;
    }
    return [];
  }, [vesselDefectList, checkedData]);

  const handleCheckBoxWithKey = (id: string) => {
    const jobIds: TypeDefectList[] = [...checkedData];
    const updatedData = data?.map((element: TypeDefectList) => {
      if (element?.id === id) {
        if (!element.isChecked) {
          jobIds.push(element);
        } else {
          const ind = jobIds.findIndex((ele) => ele?.id === id);
          jobIds.splice(ind, 1);
        }
        return {
          ...element,
          isChecked: !element?.isChecked,
        };
      }
      return element;
    });

    setData(updatedData);
    dispatch(setCheckedData(jobIds));
  };

  useEffect(() => {
    if (vesselDefectList) {
      setData(tableData);
    }
  }, [vesselDefectList, tableData]);

  const handleData = () => {
    const payload = {
      jobOrder: jobOrderId || '',
      vesselId: vesselId || '',
      page,
      searchQuery,
      rowsPerPage,
    };
    dispatch(getVesselDefectStart(payload));
    // setSelectedId('');
  };

  useEffect(() => {
    handleData();
  }, []);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  // const disableInsert = vesselDefectList.filter((item) => String(item.Id) === selectedId);
  const disableInsert = useMemo(() => {
    if (checkedData?.length === 1) {
      return vesselDefectList?.filter((item) => String(item?.Id) === String(checkedData[0]?.id));
    } return [];
  }, [vesselDefectList, checkedData]);

  return (
    <>
      <div className="div_container_CustomerInfo" id="edit_vessel_defect_search_row">
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12}>
                {(roleId === ANALYST_ROLE_ID) ? (
                  <DataTable<TypeDefectList>
                    data={data?.length > 0 ? data : []}
                    columns={DefectTableColumns}
                    totalRecords={totalVesselDefect}
                    page={page}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    handleData={handleData}
                    handleViews={handleEdit}
                  />
                ) : (
                  <DataTable<TypeDefectList>
                    data={data?.length > 0 ? data : []}
                    columns={DefectTableColumns}
                    totalRecords={totalVesselDefect}
                    page={page}
                    setPage={setPage}
                    rowsPerPage={rowsPerPage}
                    setRowsPerPage={setRowsPerPage}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    handleData={handleData}
                    buttonText="Add"
                    handleButtonClick={handleButtonClick}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleIssueButton={() => setShowFinishTimeModal(true)}
                    handleSearchButtonClick={() => setShowStartTimeModal(true)}
                    issueButton="Finish Time"
                    searchButton="Start Time"
                    issueButtonDisable={endTime !== null}
                    searchButtonDisable={startTime !== null}
                    // radioButtonColumnsWithKey={['sn']}
                    checkBoxWithKey={['sn']}
                    handleCheckBoxWithKey={handleCheckBoxWithKey}
                    // selectedRadioWithKey={selectedId}
                    // setSelectedRadioWithKey={setSelectedId}
                    generateInvoiceButton="Insert Time"
                    handleGenerateInvoiceButton={() => setShowInsertTimeModal(true)}
                    buttonNameFifth="Search & Replace"
                    generateInvoiceButtonDisabled={!(checkedData?.length === 1)
                      || disableInsert?.[0]?.DefectType === 'Time Entry' || disableInsert?.[0]?.DefectType === 'Calibration Time'}
                    handleButtonClickFifth={() => setShowReplaceModal(true)}
                    buttonNameSixth="Delete"
                    handleButtonClickSixth={handleMultiDelete}
                    textButtonDisabledSixth={checkedData?.length === 0}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {!(roleId === ANALYST_ROLE_ID) && (
        <>
          { showStartTimeModal && (
          <StartTimeComponent
            show={showStartTimeModal}
            setOpenFrom={() => setShowStartTimeModal(false)}
            rowId={selectedRowId}
            setRowId={setSelectedRowId}
            callback={handleData}
            label="Add Start Time"
          />
          )}
          { showFinishTimeModal && (
          <FinishTimeComponent
            show={showFinishTimeModal}
            setOpenFrom={() => setShowFinishTimeModal(false)}
            rowId={selectedRowId}
            setRowId={setSelectedRowId}
            callback={handleData}
            label="Add Finish Time"
            startTime={startTime}
          />
          )}
          {showDeleteModal
        && (
          <ComponentDeleteModal
            show={showDeleteModal}
            setOpenFrom={() => setDeleteModal(false)}
            handleDelete={multiDelete ? handleMultiDeleteConfirm : handleDeleteModal}
            multiDelete={multiDelete}
          />
        )}
          {showInsertTimeModal
      && (
      <InsertTimeComponent
        show={showInsertTimeModal}
        setOpenFrom={() => setShowInsertTimeModal(false)}
        rowId={checkedData?.length === 1 ? String(checkedData[0]?.id) : ''}
        callback={handleData}
        startTime={startTime}
        endTime={endTime}
      />
      )}
          {showReplaceModal
        && (
        <ReplaceComponent
          show={showReplaceModal}
          setOpenFrom={() => setShowReplaceModal(false)}
          rowId={selectedRowId}
          callback={handleData}
        />
        )}
        </>
      )}
      {showDefectModal
        && (
          <AddDefectComponent
            show={showDefectModal}
            setOpenFrom={() => {
              setShowDefectModal(false);
            }}
            rowId={selectedRowId}
            setRowId={setSelectedRowId}
            callback={handleData}
            disabled={roleId === ANALYST_ROLE_ID}
          />
        )}
    </>
  );
}

export default DefectComponent;
